import React, { useState } from "react";
import { CaretDown, ArrowSquareOut, WarningCircle } from "@phosphor-icons/react";

const Section = ({ s, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const has = (s.rows || []).length > 0;
  return (
    <div className="border border-slate-800 rounded-sm" data-testid={`closing-section-${s.key}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-2 px-3 py-2 text-left hover:bg-slate-900">
        <span className="text-xs text-slate-400">{s.title}</span>
        <span className="flex items-center gap-1">
          <span className="font-mono-num text-sm font-bold text-slate-100">{s.value ?? (has ? `${s.rows.length}` : "—")}</span>
          {has && <CaretDown size={12} className={"text-slate-500 transition-transform " + (open ? "rotate-180" : "")} />}
        </span>
      </button>
      {s.sub && <div className="px-3 -mt-1 pb-1 text-[11px] text-slate-500">{s.sub}</div>}
      {open && (
        <div className="px-3 pb-2 space-y-1" data-testid={`closing-rows-${s.key}`}>
          {(s.rows || []).map((r, i) => (
            <div key={i} className="text-xs">
              <div className="flex justify-between gap-2"><span className="text-slate-300 truncate">{r.label}</span><span className="font-mono-num text-slate-100">{r.value}</span></div>
              {r.sub && <div className="text-[10px] text-slate-500">{r.sub}</div>}
            </div>
          ))}
          {s.page && onNavigate && (
            <button type="button" onClick={() => onNavigate(s.page)} className="text-[11px] text-orange-300 flex items-center gap-1 pt-1" data-testid={`closing-open-${s.key}`}>
              <ArrowSquareOut size={12} /> Page kholo
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export const ClosingCard = ({ c, onNavigate }) => (
  <div className="space-y-2" data-testid="closing-card">
    <div className="text-[11px] tracking-widest text-orange-300 font-mono-num">CLOSING · {c.date}</div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
      {c.sections.map((s) => <Section key={s.key} s={s} onNavigate={onNavigate} />)}
    </div>
    {c.attention?.length > 0 && (
      <div className="border border-amber-500/40 bg-amber-500/5 rounded-sm p-2" data-testid="closing-attention">
        <div className="text-xs text-amber-300 font-bold flex items-center gap-1 mb-1"><WarningCircle size={14} /> DHYAN DEIN</div>
        {c.attention.map((a, i) => <div key={i} className="text-xs text-amber-100">• {a}</div>)}
      </div>
    )}
  </div>
);
